/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tmpl = __webpack_require__(1);
var TG_FULLSCREEN_KEY = 'TG_FULLSCREEN_KEY';
adv.AdBase.extend('AdMobileMadGlobalScreenMask', {
  init: function init(options) {
    this.base(options);

    if (window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
      return false;
    }

    this.emit(adv.ENUM.EVENTS.inited);
  },
  setup: function setup(data) {
    this.data = data;
    var ignore = this.validate();
    if (!ignore) {
      this.emit(adv.ENUM.EVENTS.setuped);
    }
  },
  play: function play() {
    var _self = this;
    var data = this.data;
    var advEl = $(this.options.selector);

    if (adv.storage.get(TG_FULLSCREEN_KEY)) {
      return;
    }

    advEl.append(adv.razor(tmpl, {
      image: data.image,
      link: data.link,
      bbsClass: window.location.hostname === 'bbs.17173.com' ? 'tg-fullscreen-bbs' : '',
      advid: this.options.id
    }));

    adv.$('.tg-fullscreen .tg-fullscreen-in .tg-fullscreen-close').on('click', function () {
      adv.$('.tg-fullscreen').hide();
      _self.setStorage(TG_FULLSCREEN_KEY);
    });
    this.emit(adv.ENUM.EVENTS.played);
  },
  validate: function validate() {
    return window.location.hostname === 'news.17173.com' && (window.location.href.indexOf('news.17173.com\/z\/yys') > -1 || window.location.href.indexOf('news.17173.com\/m\/z\/yys') > -1 || window.location.href.indexOf('news.17173.com\/z\/pvp') > -1 || window.location.href.indexOf('news.17173.com\/m\/z\/pvp') > -1) && new Date().getTime() >= new Date('2016/12/26 00:00:00').getTime() && new Date().getTime() < new Date('2017/1/1 00:00:00').getTime();
  },
  setStorage: function setStorage(key) {
    var now = new Date();
    var todayEnd = new Date(now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate() + ' 23:59:59').getTime();
    adv.storage.set(key, 'ignoreThis', todayEnd - Date.now(), '17173.com', '/');
  }
});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .tg-fullscreen{ position: fixed; z-index: 1100; top:0; right:0; bottom:0; left:0; background:rgba(0,0,0,.5);}\n    .tg-fullscreen .tg-fullscreen-in{ position: absolute; top:50%; left:50%; width:84%; max-width:550px; text-align: center; white-space: nowrap; -webkit-transform:translate(-50%,-50%); -ms-transform:translate(-50%,-50%); transform:translate(-50%,-50%);}\n    .tg-fullscreen img{ width: 100%; max-height: 100%; vertical-align: top;}\n    .tg-fullscreen .tg-fullscreen-close{ display: inline-block; width:25px; height: 25px; margin:-12px 0 0 -12px; font: normal 24px/25px \"sans-serif\"; color:#fff; text-align: center; text-decoration: none; background-color: #000; border:2px solid #fff; border-radius: 100%; vertical-align: top}\n    .tg-fullscreen-bbs .tg-fullscreen-close{ -webkit-transform:scale(.77); -ms-transform:scale(.77); transform:scale(.77);}\n    @media only screen and (orientation:landscape){.tg-fullscreen .tg-fullscreen-in{height: 90%;}}\n</style>\n<div class=\"tg-fullscreen @advid @bbsClass\">\n    <div class=\"tg-fullscreen-in\">\n        <a href=\"@link\"><img src=\"@image\" alt=\"\" width=\"275px\" height=\"340px\"></a><a href=\"javascript:;\" class=\"tg-fullscreen-close\">×</a>\n    </div>\n</div>"

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// v1-0/production.js